import type { Reducer } from 'react';
import type { RecentDealsState } from '../types';
import type { Action } from '@makemydeal/dr-shared-store';
import {
    FETCH_RECENT_DEALS_REQUEST,
    FETCH_RECENT_DEALS_SUCCESS,
    FETCH_RECENT_DEALS_FAILURE,
    SHOW_RECENT_DEALS,
    HIDE_RECENT_DEALS,
    SELECT_DEAL
} from './actions';
import { FETCH_RECENT_DEALS_FAILURE_MESSAGE, ERROR, UNKNOWN_ERROR_OCCURRED } from '../constants';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import { recentDealsInitialState } from './initialState';

export type RecentDealsReducer = Reducer<RecentDealsState, Action>;

export const recentDealsReducer: Reducer<RecentDealsState, Action> = (
    state: RecentDealsState = recentDealsInitialState,
    action: Action
): RecentDealsState => {
    const { payload, type } = action;

    switch (type) {
        case FETCH_RECENT_DEALS_REQUEST: {
            return {
                ...state,
                requestStatus: ApiRequestStatus.Loading,
                errorDetails: undefined
            };
        }

        case FETCH_RECENT_DEALS_SUCCESS: {
            const { deals = [] } = payload.data || {};

            return {
                ...state,
                deals: deals,
                requestStatus: ApiRequestStatus.Success,
                errorDetails: undefined
            };
        }

        case FETCH_RECENT_DEALS_FAILURE: {
            return {
                ...state,
                errorDetails: {
                    message: payload?.message || UNKNOWN_ERROR_OCCURRED,
                    label: FETCH_RECENT_DEALS_FAILURE_MESSAGE,
                    type: ERROR
                },
                requestStatus: ApiRequestStatus.Error
            };
        }

        case SHOW_RECENT_DEALS:
        case HIDE_RECENT_DEALS: {
            return {
                ...state,
                deals: [],
                requestStatus: type === SHOW_RECENT_DEALS ? ApiRequestStatus.Idle : ApiRequestStatus.Success,
                showRecentDeals: type === SHOW_RECENT_DEALS ? true : false
            };
        }

        case SELECT_DEAL: {
            const updatedDeals = state.deals.map((deal) => {
                if (deal.dealId === payload.dealId) {
                    return {
                        ...deal,
                        isSelected: true
                    };
                }
                return {
                    ...deal,
                    isSelected: false
                };
            });

            return {
                ...state,
                deals: [...updatedDeals]
            };
        }

        default: {
            return state;
        }
    }
};
